import { op_Division, fromParts, op_Addition, op_Multiply } from "../../fable_modules/fable-library.3.7.20/Decimal.js";
import { Union, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { tuple_type, option_type, list_type, bool_type, int32_type, union_type, record_type, string_type, class_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { map as map_1, empty, tryHead, ofArray } from "../../fable_modules/fable-library.3.7.20/List.js";
import { ProductModule_ofInt, CancelDateChoice, PeriodModule_toString, PeriodModule_toInt, Period as Period_1, PeriodModule_getOptions, PeriodModule_ofString, PeriodModule_getOptionsV2, Product$reflection, CancelDateChoice$reflection, Period$reflection } from "../../DomainTypes.js";
import { bind, map, defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { parseInt$ } from "../../Utils.js";
import { getVatRates, afterSomeTimeSelects } from "../../CommonData.js";
import { ofList as ofList_1, empty as empty_1 } from "../../fable_modules/fable-library.3.7.20/Map.js";
import { contains, ofList, empty as empty_2 } from "../../fable_modules/fable-library.3.7.20/Set.js";
import { comparePrimitives, compare } from "../../fable_modules/fable-library.3.7.20/Util.js";

export function getAmountInclVat(amountExclVat, selectedVatRatePercent) {
    return op_Multiply(amountExclVat, op_Addition(fromParts(10, 0, 0, false, 1), op_Division(selectedVatRatePercent, fromParts(1000, 0, 0, false, 1))));
}

export class ChartOfAccount extends Record {
    constructor(AccountNo, Description, CostCentre) {
        super();
        this.AccountNo = AccountNo;
        this.Description = Description;
        this.CostCentre = CostCentre;
    }
}

export function ChartOfAccount$reflection() {
    return record_type("Containers.FeeTemplates.Model.ChartOfAccount", [], ChartOfAccount, () => [["AccountNo", class_type("System.Decimal")], ["Description", string_type], ["CostCentre", string_type]]);
}

export class UseTemplateWhen extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["CreatingActivity", "CreatingContract", "ChangeImsi", "TransferContract", "TemplateInCreateFee", "CreatingCampaignContract", "SignContract"];
    }
}

export function UseTemplateWhen$reflection() {
    return union_type("Containers.FeeTemplates.Model.UseTemplateWhen", [], UseTemplateWhen, () => [[], [], [], [], [], [], []]);
}

export function UseTemplateWhenModule_toString(_arg) {
    switch (_arg.tag) {
        case 1: {
            return "CreatingContract";
        }
        case 2: {
            return "ChangeImsi";
        }
        case 3: {
            return "TransferContract";
        }
        case 4: {
            return "TemplateInCreateFee";
        }
        case 5: {
            return "CreatingCampaignContract";
        }
        case 6: {
            return "SignContract";
        }
        default: {
            return "CreatingActivity";
        }
    }
}

export function UseTemplateWhenModule_ofString(_arg) {
    switch (_arg) {
        case "CreatingActivity": {
            return new UseTemplateWhen(0);
        }
        case "CreatingContract": {
            return new UseTemplateWhen(1);
        }
        case "ChangeImsi": {
            return new UseTemplateWhen(2);
        }
        case "TransferContract": {
            return new UseTemplateWhen(3);
        }
        case "TemplateInCreateFee": {
            return new UseTemplateWhen(4);
        }
        case "CreatingCampaignContract": {
            return new UseTemplateWhen(5);
        }
        case "SignContract": {
            return new UseTemplateWhen(6);
        }
        default: {
            throw (new Error(toText(printf("[UseTemplateWhen ofString] No interpretation for string: %s"))(_arg)));
        }
    }
}

export function UseTemplateWhenModule_ofInt(_arg) {
    switch (_arg) {
        case 0: {
            return new UseTemplateWhen(0);
        }
        case 1: {
            return new UseTemplateWhen(1);
        }
        case 2: {
            return new UseTemplateWhen(2);
        }
        case 3: {
            return new UseTemplateWhen(3);
        }
        case 4: {
            return new UseTemplateWhen(4);
        }
        case 5: {
            return new UseTemplateWhen(5);
        }
        case 6: {
            return new UseTemplateWhen(6);
        }
        default: {
            throw (new Error(toText(printf("[UseTemplateWhen ofInt] No interpretation for number: %i"))(_arg)));
        }
    }
}

export function UseTemplateWhenModule_toInt(_arg) {
    switch (_arg.tag) {
        case 1: {
            return 1;
        }
        case 2: {
            return 2;
        }
        case 3: {
            return 3;
        }
        case 4: {
            return 4;
        }
        case 5: {
            return 5;
        }
        case 6: {
            return 6;
        }
        default: {
            return 0;
        }
    }
}

export function UseTemplateWhenModule_toTranslation(getTranslation, _arg) {
    switch (_arg.tag) {
        case 1: {
            return getTranslation("ContractType.FeeTemplate.UseWhen.CreatingContract");
        }
        case 2: {
            return getTranslation("ContractType.FeeTemplate.UseWhen.ChangeImsi");
        }
        case 3: {
            return getTranslation("ContractType.FeeTemplate.UseWhen.TransferContract");
        }
        case 4: {
            return getTranslation("ContractType.FeeTemplate.UseWhen.TemplateInCreateFee");
        }
        case 5: {
            return getTranslation("ContractType.FeeTemplate.UseWhen.CreatingCampaignContract");
        }
        case 6: {
            return getTranslation("ContractType.FeeTemplate.UseWhen.SignContract");
        }
        default: {
            return getTranslation("ContractType.FeeTemplate.UseWhen.CreatingActivity");
        }
    }
}

export function UseTemplateWhenModule_getAll(getTranslation) {
    return ofArray([[new UseTemplateWhen(0), getTranslation("ContractType.FeeTemplate.UseWhen.CreatingActivity")], [new UseTemplateWhen(1), getTranslation("ContractType.FeeTemplate.UseWhen.CreatingContract")], [new UseTemplateWhen(2), getTranslation("ContractType.FeeTemplate.UseWhen.ChangeImsi")], [new UseTemplateWhen(3), getTranslation("ContractType.FeeTemplate.UseWhen.TransferContract")], [new UseTemplateWhen(4), getTranslation("ContractType.FeeTemplate.UseWhen.TemplateInCreateFee")], [new UseTemplateWhen(5), getTranslation("ContractType.FeeTemplate.UseWhen.CreatingCampaignContract")], [new UseTemplateWhen(6), getTranslation("ContractType.FeeTemplate.UseWhen.SignContract")]]);
}

export class ContractTypeInfo extends Record {
    constructor(ContractTypeCode, Display, ProductNr, Active) {
        super();
        this.ContractTypeCode = ContractTypeCode;
        this.Display = Display;
        this.ProductNr = (ProductNr | 0);
        this.Active = Active;
    }
}

export function ContractTypeInfo$reflection() {
    return record_type("Containers.FeeTemplates.Model.ContractTypeInfo", [], ContractTypeInfo, () => [["ContractTypeCode", string_type], ["Display", string_type], ["ProductNr", int32_type], ["Active", bool_type]]);
}

export class ContractTypeDetails extends Record {
    constructor(ContractTypes, SelectedContractTypes, SelectedProducts) {
        super();
        this.ContractTypes = ContractTypes;
        this.SelectedContractTypes = SelectedContractTypes;
        this.SelectedProducts = SelectedProducts;
    }
}

export function ContractTypeDetails$reflection() {
    return record_type("Containers.FeeTemplates.Model.ContractTypeDetails", [], ContractTypeDetails, () => [["ContractTypes", list_type(ContractTypeInfo$reflection())], ["SelectedContractTypes", list_type(string_type)], ["SelectedProducts", list_type(int32_type)]]);
}

export class FeeTemplate extends Record {
    constructor(AccountNo, Active, BoundMonths, CancellationPeriodMonths, ContractTypeCodes, Description, EndFeeAfterMonths, Fee, FeeTemplateNr, MonthsInAdvance, Period, PeriodDesc, ProductNrs, SortIndex, UntilFurtherNotice, UseWhen, VatRatePercent, Units, Attribute, AttributeValue, NrOfContractsUsingFeeTemplate) {
        super();
        this.AccountNo = (AccountNo | 0);
        this.Active = Active;
        this.BoundMonths = (BoundMonths | 0);
        this.CancellationPeriodMonths = (CancellationPeriodMonths | 0);
        this.ContractTypeCodes = ContractTypeCodes;
        this.Description = Description;
        this.EndFeeAfterMonths = (EndFeeAfterMonths | 0);
        this.Fee = Fee;
        this.FeeTemplateNr = (FeeTemplateNr | 0);
        this.MonthsInAdvance = (MonthsInAdvance | 0);
        this.Period = (Period | 0);
        this.PeriodDesc = PeriodDesc;
        this.ProductNrs = ProductNrs;
        this.SortIndex = SortIndex;
        this.UntilFurtherNotice = UntilFurtherNotice;
        this.UseWhen = UseWhen;
        this.VatRatePercent = VatRatePercent;
        this.Units = (Units | 0);
        this.Attribute = Attribute;
        this.AttributeValue = AttributeValue;
        this.NrOfContractsUsingFeeTemplate = (NrOfContractsUsingFeeTemplate | 0);
    }
}

export function FeeTemplate$reflection() {
    return record_type("Containers.FeeTemplates.Model.FeeTemplate", [], FeeTemplate, () => [["AccountNo", int32_type], ["Active", bool_type], ["BoundMonths", int32_type], ["CancellationPeriodMonths", int32_type], ["ContractTypeCodes", list_type(string_type)], ["Description", string_type], ["EndFeeAfterMonths", int32_type], ["Fee", class_type("System.Decimal")], ["FeeTemplateNr", int32_type], ["MonthsInAdvance", int32_type], ["Period", int32_type], ["PeriodDesc", string_type], ["ProductNrs", list_type(int32_type)], ["SortIndex", option_type(int32_type)], ["UntilFurtherNotice", bool_type], ["UseWhen", list_type(int32_type)], ["VatRatePercent", class_type("System.Decimal")], ["Units", int32_type], ["Attribute", option_type(string_type)], ["AttributeValue", option_type(string_type)], ["NrOfContractsUsingFeeTemplate", int32_type]]);
}

export class FeeTemplateViewModel extends Record {
    constructor(Description, AmountExclVat, AmountInclVat, FeeTemplateNr, SelectedVatRatePercent, SelectedPeriod, SelectedCancelDateChoice, ProductCheckedStates, ContractTypesCheckedStates, SelectedUseWhen, MonthsInAdvance, CancellationPeriodMonths, BoundMonths, UntilFurtherNotice, EndFeeAfterMonths, UseWhen, SelectedAccountNo, SortIndex, ErrorMessage, Units, SelectedAttribute, AttributeValue) {
        super();
        this.Description = Description;
        this.AmountExclVat = AmountExclVat;
        this.AmountInclVat = AmountInclVat;
        this.FeeTemplateNr = (FeeTemplateNr | 0);
        this.SelectedVatRatePercent = SelectedVatRatePercent;
        this.SelectedPeriod = SelectedPeriod;
        this.SelectedCancelDateChoice = SelectedCancelDateChoice;
        this.ProductCheckedStates = ProductCheckedStates;
        this.ContractTypesCheckedStates = ContractTypesCheckedStates;
        this.SelectedUseWhen = SelectedUseWhen;
        this.MonthsInAdvance = (MonthsInAdvance | 0);
        this.CancellationPeriodMonths = (CancellationPeriodMonths | 0);
        this.BoundMonths = (BoundMonths | 0);
        this.UntilFurtherNotice = UntilFurtherNotice;
        this.EndFeeAfterMonths = (EndFeeAfterMonths | 0);
        this.UseWhen = UseWhen;
        this.SelectedAccountNo = (SelectedAccountNo | 0);
        this.SortIndex = SortIndex;
        this.ErrorMessage = ErrorMessage;
        this.Units = (Units | 0);
        this.SelectedAttribute = SelectedAttribute;
        this.AttributeValue = AttributeValue;
    }
}

export function FeeTemplateViewModel$reflection() {
    return record_type("Containers.FeeTemplates.Model.FeeTemplateViewModel", [], FeeTemplateViewModel, () => [["Description", string_type], ["AmountExclVat", class_type("System.Decimal")], ["AmountInclVat", class_type("System.Decimal")], ["FeeTemplateNr", int32_type], ["SelectedVatRatePercent", class_type("System.Decimal")], ["SelectedPeriod", Period$reflection()], ["SelectedCancelDateChoice", option_type(CancelDateChoice$reflection())], ["ProductCheckedStates", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [Product$reflection(), bool_type])], ["ContractTypesCheckedStates", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, tuple_type(ContractTypeInfo$reflection(), bool_type)])], ["SelectedUseWhen", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [UseTemplateWhen$reflection()])], ["MonthsInAdvance", int32_type], ["CancellationPeriodMonths", int32_type], ["BoundMonths", int32_type], ["UntilFurtherNotice", bool_type], ["EndFeeAfterMonths", int32_type], ["UseWhen", list_type(int32_type)], ["SelectedAccountNo", int32_type], ["SortIndex", option_type(int32_type)], ["ErrorMessage", option_type(string_type)], ["Units", int32_type], ["SelectedAttribute", string_type], ["AttributeValue", string_type]]);
}

export function getInitFeeTemplate(globalDeps) {
    let matchValue_1;
    const period = defaultArg(globalDeps.ClientConfig.EnableFeesV2 ? tryHead(PeriodModule_getOptionsV2(globalDeps.ClientConfig.FeeConfig)) : map((arg) => PeriodModule_ofString(arg[0]), tryHead(PeriodModule_getOptions((x) => x))), new Period_1(1));
    return new FeeTemplate(0, false, 0, 0, empty(), "", defaultArg(bind((arg_1) => parseInt$(arg_1[0]), tryHead(afterSomeTimeSelects((x_1) => x_1))), 1), fromParts(0, 0, 0, false, 1), 0, 1, PeriodModule_toInt(period), PeriodModule_toString(period), empty(), void 0, true, empty(), (matchValue_1 = tryHead(getVatRates(globalDeps.CountryCode)), (matchValue_1 == null) ? (() => {
        throw (new Error("Could not get vat rate."));
    })() : matchValue_1), 1, void 0, void 0, 0);
}

export function initFeeTemplateViewModel(globalDeps) {
    const initFeeTemplate = getInitFeeTemplate(globalDeps);
    return new FeeTemplateViewModel(initFeeTemplate.Description, initFeeTemplate.Fee, getAmountInclVat(initFeeTemplate.Fee, initFeeTemplate.VatRatePercent), initFeeTemplate.FeeTemplateNr, initFeeTemplate.VatRatePercent, new Period_1(0), void 0, empty_1(), empty_1(), empty_2({
        Compare: compare,
    }), initFeeTemplate.MonthsInAdvance, initFeeTemplate.CancellationPeriodMonths, initFeeTemplate.BoundMonths, initFeeTemplate.UntilFurtherNotice, initFeeTemplate.EndFeeAfterMonths, empty(), initFeeTemplate.AccountNo, initFeeTemplate.SortIndex, void 0, 1, defaultArg(initFeeTemplate.Attribute, ""), defaultArg(initFeeTemplate.AttributeValue, ""));
}

export function getCancelDateChoice(untilFurtherNotice, endFeeAfterMonths) {
    if (untilFurtherNotice) {
        return new CancelDateChoice(0);
    }
    else if (endFeeAfterMonths > 0) {
        return new CancelDateChoice(2);
    }
    else {
        return void 0;
    }
}

export function toViewModel(ft, detailsLoadState) {
    let details, checkedProducts, details_1, checkedContractTypes;
    return new FeeTemplateViewModel(ft.Description, ft.Fee, getAmountInclVat(ft.Fee, ft.VatRatePercent), ft.FeeTemplateNr, ft.VatRatePercent, PeriodModule_ofString(ft.PeriodDesc), getCancelDateChoice(ft.UntilFurtherNotice, ft.EndFeeAfterMonths), (detailsLoadState.tag === 1) ? empty_1() : ((detailsLoadState.tag === 3) ? empty_1() : ((detailsLoadState.tag === 2) ? ((details = detailsLoadState.fields[0], (checkedProducts = ofList(details.SelectedProducts, {
        Compare: comparePrimitives,
    }), ofList_1(map_1((contractType) => [ProductModule_ofInt(contractType.ProductNr), contains(contractType.ProductNr, checkedProducts)], details.ContractTypes))))) : empty_1())), (detailsLoadState.tag === 1) ? empty_1() : ((detailsLoadState.tag === 3) ? empty_1() : ((detailsLoadState.tag === 2) ? ((details_1 = detailsLoadState.fields[0], (checkedContractTypes = ofList(details_1.SelectedContractTypes, {
        Compare: comparePrimitives,
    }), ofList_1(map_1((contractType_1) => [contractType_1.ContractTypeCode, [contractType_1, contains(contractType_1.ContractTypeCode, checkedContractTypes)]], details_1.ContractTypes))))) : empty_1())), ofList(map_1(UseTemplateWhenModule_ofInt, ft.UseWhen), {
        Compare: compare,
    }), ft.MonthsInAdvance, ft.CancellationPeriodMonths, ft.BoundMonths, ft.UntilFurtherNotice, ft.EndFeeAfterMonths, ft.UseWhen, ft.AccountNo, ft.SortIndex, void 0, ft.Units, defaultArg(ft.Attribute, ""), defaultArg(ft.AttributeValue, ""));
}

export class FeeTemplateDTO extends Record {
    constructor(Description, Fee, VatRatePercent, Period, PeriodDesc, MonthsInAdvance, CancellationPeriodMonths, BoundMonths, UntilFurtherNotice, EndFeeAfterMonths, UseWhen, Products, ContractTypeCodes, AccountNo, SortIndex, Units, Attribute, AttributeValue) {
        super();
        this.Description = Description;
        this.Fee = Fee;
        this.VatRatePercent = VatRatePercent;
        this.Period = (Period | 0);
        this.PeriodDesc = PeriodDesc;
        this.MonthsInAdvance = (MonthsInAdvance | 0);
        this.CancellationPeriodMonths = (CancellationPeriodMonths | 0);
        this.BoundMonths = (BoundMonths | 0);
        this.UntilFurtherNotice = UntilFurtherNotice;
        this.EndFeeAfterMonths = (EndFeeAfterMonths | 0);
        this.UseWhen = UseWhen;
        this.Products = Products;
        this.ContractTypeCodes = ContractTypeCodes;
        this.AccountNo = (AccountNo | 0);
        this.SortIndex = SortIndex;
        this.Units = (Units | 0);
        this.Attribute = Attribute;
        this.AttributeValue = AttributeValue;
    }
}

export function FeeTemplateDTO$reflection() {
    return record_type("Containers.FeeTemplates.Model.FeeTemplateDTO", [], FeeTemplateDTO, () => [["Description", string_type], ["Fee", string_type], ["VatRatePercent", class_type("System.Decimal")], ["Period", int32_type], ["PeriodDesc", string_type], ["MonthsInAdvance", int32_type], ["CancellationPeriodMonths", int32_type], ["BoundMonths", int32_type], ["UntilFurtherNotice", bool_type], ["EndFeeAfterMonths", int32_type], ["UseWhen", list_type(int32_type)], ["Products", list_type(int32_type)], ["ContractTypeCodes", list_type(string_type)], ["AccountNo", int32_type], ["SortIndex", option_type(int32_type)], ["Units", int32_type], ["Attribute", option_type(string_type)], ["AttributeValue", option_type(string_type)]]);
}

export class FeeTemplateEvent extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["OnChangeDescription", "OnChangeAmountExclVat", "OnChangeAmountInclVat", "SelectVatRate", "SelectPeriod", "SelectMonthsInAdvance", "SelectCancellationPeriod", "SelectCancelDateChoice", "SelectEndAfterSomeTime", "OnChangeBoundMonths", "SelectUseWhen", "SetSelectedProduct", "SetSelectedContractType", "LoadedContractTypeDetails", "SelectAllContractTypes", "DeSelectAllContractTypes", "OnChangeAccountNo", "OnChangeSortIndex", "OnChangeUnits", "SelectAttribute", "OnChangeAttributeValue"];
    }
}

export function FeeTemplateEvent$reflection() {
    return union_type("Containers.FeeTemplates.Model.FeeTemplateEvent", [], FeeTemplateEvent, () => [[["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item1", UseTemplateWhen$reflection()], ["Item2", bool_type]], [["Item1", Product$reflection()], ["Item2", bool_type]], [["Item1", ContractTypeInfo$reflection()], ["Item2", bool_type]], [["Item", ContractTypeDetails$reflection()]], [], [], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]]]);
}

